// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/3918
import type { PAPEventGeneric } from "../base/event";
import type { DashProfileType } from "../enums/dash_profile_type";
import type { DashProfileAction } from "../enums/dash_profile_action";
import type { DashSurface } from "../enums/dash_surface";
import type { DashActionSurface } from "../enums/dash_action_surface";
import type { FeatureLine } from "../enums/feature_line";
import type { DashProfileSection } from "../enums/dash_profile_section";

// Event_name: 'click.dash_profile_page'
// Description: User clicked on Dash Profile Page
// Owner: pulse-team
export type Click_DashProfilePage = PAPEventGeneric<
  'dash',
  'click',
  'dash_profile_page',
  {
    // Type of Profile Page in Dash
    dashProfileType?: DashProfileType;
    // Type of action take on Dash Profile Page
    dashProfileAction?: DashProfileAction;
    // Which Dash surface (web, desktop, or browser extension) the event originated from.
    dashSurface?: DashSurface;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // Feature Line for dash
    featureLine?: FeatureLine;
    // The section within a Dash Profile Page where the action takes place (e.g. "New Arrivals" or "Direct Reports")
    dashProfileSection?: DashProfileSection;
  }
>;

export function PAP_Click_DashProfilePage(properties?: Click_DashProfilePage['properties']): Click_DashProfilePage {
  return <Click_DashProfilePage>{
    class: 'dash',
    action: 'click',
    object: 'dash_profile_page',
    properties,
  };
}
